import React from 'react';

type LiveStreamingIconProps = {
  color?: string;
};

export default function LiveStreamingIcon({ color }: LiveStreamingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      color={color}
      fill={'none'}
    >
      <circle
        cx="12"
        cy="12"
        r="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 8C6.5 9 6 10.5 6 12C6 13.5 6.5 15 7.5 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 6C3 7.5 2 9.5 2 12C2 14.5 3 16.5 4.5 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16C17.5 15 18 13.5 18 12C18 10.5 17.5 9 16.5 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 18C21 16.5 22 14.5 22 12C22 9.5 21 7.5 19.5 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
